<template>
        <div class="row mt-5">

            <template v-if="mainalign == 'right'">

                <div class="col-sm align-middle d-none d-sm-block">
                    <div class="row mt-4">
                        <div class="offset-sm-0 offset-md-3 offset-lg-5 offset-xl-7 col-sm-12 col-md-9 col-lg-7 col-xl-5 pr-0">
                            <p class="ss-title text-right entryTitle">{{ maintitle }}</p>
                            <p class="ss-text text-right collapse" :id="'collapse' + carouselid" aria-expanded="false">{{ maintext }}</p>
                            <a role="button" class="float-right collapsed" data-toggle="collapse" :href="'#collapse' + carouselid" aria-expanded="false" :aria-controls="'collapse' + carouselid"></a>
                        </div>
                    </div>
                </div>
                <div class="col-sm">
                    <Slideshow :carouselid="carouselid" :images="images"></Slideshow>
                </div>
                <!-- mobile only -->
                <div class="col-sm align-middle d-block d-sm-none">
                    <div class="row mt-0">
                        <div class="col-sm">
                            <p class="ss-title text-left entryTitle">{{ maintitle }}</p>
                            <p class="ss-text text-left collapse" :id="'collapse' + carouselid" aria-expanded="false">{{ maintext }}</p>
                            <a role="button" class="float-left collapsed" data-toggle="collapse" :href="'#collapse' + carouselid" aria-expanded="false" :aria-controls="'collapse' + carouselid"></a>
                        </div>
                    </div>
                </div>

            </template>

            <template v-if="mainalign == 'left'">

                <div class="col-sm">
                    <Slideshow :carouselid="carouselid" :images="images"></Slideshow>
                </div>
                <div class="col-sm align-middle pl-0 d-none d-sm-block">
                    <div class="row mt-4">
                        <div class="col-sm-12 col-md-9 col-lg-7 col-xl-5">
                            <p class="ss-title text-left entryTitle">{{ maintitle }}</p>
                            <p class="ss-text text-left collapse" :id="'collapse' + carouselid" aria-expanded="false">{{ maintext }}</p>
                            <a role="button" class="float-left collapsed" data-toggle="collapse" :href="'#collapse' + carouselid" aria-expanded="false" :aria-controls="'collapse' + carouselid"></a>
                        </div>

                    </div>
                </div>
                <!-- mobile only -->
                <div class="col-sm align-middle d-block d-sm-none">
                    <div class="row mt-0">
                        <div class="col-sm">
                            <p class="ss-title text-left entryTitle">{{ maintitle }}</p>
                            <p class="ss-text text-left collapse" :id="'collapse' + carouselid" aria-expanded="false">{{ maintext }}</p>
                            <a role="button" class="float-left collapsed" data-toggle="collapse" :href="'#collapse' + carouselid" aria-expanded="false" :aria-controls="'collapse' + carouselid"></a>
                        </div>
                    </div>
                </div>
            </template>

        </div>
</template>

<script>
import Slideshow from '@/components/Slideshow.vue'

export default {
  name: 'Entry',

  props: {
    mainalign: String,
    maintext: Text,
    maintitle: Text,
    carouselid: String,
    images: Array
  },
  components: {
    Slideshow
  },
  data (){
      return {
      }
  }
}
</script>
<style scoped>
p {
    margin-bottom: .2rem;

}
.ss-title{
    line-height: 1.2rem;
    letter-spacing: 0.1rem;
    text-transform: uppercase;
}
.ss-text{
    line-height: 1.05rem;
    letter-spacing: 0.05rem;
    text-transform: initial!important;
}

.entryTitle {
    text-transform: none;
}

p.show {
    height: max-content!important;
}
p.collapse[aria-expanded="false"] {
    display: block;
    height: 68px;
    overflow: hidden;
}

p.collapsing[aria-expanded="false"] {
    height: 68px;
}

a.collapsed:after  {
    content: 'More';
    color: #2c3e50;
    text-decoration: underline;
}

a:not(.collapsed):after {
    content: 'Less';
    color: #2c3e50;
    text-decoration: underline;
}
a.collapsed:hover,a.collapsed:visited{
    color:#2c3e50 !important;
}
</style>